import  Carousel from './common/Carousel'
import {useTranslation} from 'react-i18next'
import {imagenesCarousel} from '../data/data'
import {useMobileDetection} from '../hook/useMobileDetection'

export const Inicio = () => {
  
  const { t } = useTranslation()
  const isMobile = useMobileDetection
  
  const BANNER_SRC = `/image/inicio/BANNER${isMobile()?"_MOBILE":""}.webp`

  return (
    <div>
      <div className='hero-container hero-dark-gradient'>
        <img src={BANNER_SRC} alt="banner" className='hero-bg hero-alive'/>
        <div className='hero-title'>          
          <h1 style={{color:"white"}}>{t("inicio_hero")}</h1>
        </div>
      </div>
      <div className='container mt-5'>            
        <div className='flex-panel'>
          <div /* style={{"--custom-width":"35%"}} */>
            <img src="\image\inicio\FX300060.webp" alt='img' className='w-100'/>
          </div>
          <div className='p-5' /* style={{"--custom-width":"65%"}} */>
            <h2>{t("inicio_cabecera1")}</h2>
            <h5>{t("inicio_sub_cabecera1")}</h5>
            <p className='text-justify'>{t("inicio_texto1")}</p>
          </div>
        </div>
      </div>
      <div className='container mt-5 mb-5'>
        <h2>{t("inicio_cabecera2")}</h2>
        <Carousel imagenesCarousel={imagenesCarousel}/>
      </div>         
    </div>
  )
}
